import { captureException } from "@sentry/vue";

import { PUSH_PLATFORM } from "../Models/constants";

import { type PushNotificationStore, usePushNotificationsStore } from "../Store";

import PushNotificationsAPIConnector from "@/Services/TherapyApi/PushNotifications";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";
import { isAndroidApp } from "@/Utils/Ionic";

class DeletePushTokenActionHandler {
  constructor(
    private readonly pushStore: PushNotificationStore = usePushNotificationsStore(),
    private readonly pushApi = new PushNotificationsAPIConnector()
  ) {}

  public async handle(token: string): Promise<boolean> {
    this.pushStore.token = undefined;

    try {
      const response = await this.pushApi.deleteTokens(
        token,
        isAndroidApp() ? PUSH_PLATFORM.ANDROID : PUSH_PLATFORM.IOS
      );

      if (hasValue(response)) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      danger("Error deleting push token");

      captureException(e);

      return false;
    }
  }
}

export default DeletePushTokenActionHandler;
